import React, { Component } from 'react';
import { Link } from "react-router-dom";

class Map extends Component {
  constructor(props) {
    super(props);
    this.initMap = this.initMap.bind(this);
  }

  initMap() {
    if (typeof window.google ==='undefined') {
      setTimeout(this.initMap, 1000);
      return
    }
    const myLatlng = new window.google.maps.LatLng(58.014432, 56.253019);
    const myOptions = {
      zoom: 17,
      center: myLatlng,
      mapTypeId: window.google.maps.MapTypeId.ROADMAP
    };
    const map = new window.google.maps.Map(document.getElementById("map"), myOptions);

    const marker = new window.google.maps.Marker({
      position: myLatlng,
      map: map,
      title: "Автошкола"
    });

    const infowindow = new window.google.maps.InfoWindow({
      content: "<b>Автошкола «Дизель»</b>"
    });

    infowindow.open(map, marker);
  }

  componentDidMount() {
    this.initMap();
  }

  render() {
    return (
      <div className="map">
        <div id="map" />
        <div className="map__tooltip">
          <h3>Как нас найти?</h3>
          <p>
            +7 (951) 938-40-29
            <br />
            г. Пермь, ул. Максима Горького, 21
            <br />
            <Link to="/message" className="link">
              Напишите нам
            </Link>
          </p>
        </div>
      </div>
    );
  }
}

export default Map;


// WEBPACK FOOTER //
// ./src/components/About/Common/Map.jsx